import type { ResAllType } from '../../Types/Api/All'
import type { SiteType, SiteUpdateReq } from '../../Types/Api/Site'
import { api } from './API'
import { isResErrorType, requireAuth } from './Auth'

export const allSites = async () => {
  const res = await requireAuth<ResAllType<SiteType>>(api.get('sites'))
  if (res.ok && res.data && !isResErrorType(res.data)) {
    return res.data.data
  }

  return []
}

export const createSite = async (values) => {
  const res = await requireAuth<any>(api.post('sites', values))

  if (res.ok) {
    return res.data
  }

  return null
}

export const findSite = async (name) => {
  return await requireAuth<any>(api.get(`sites`, { site_name: name }))
}

export const updateSite = async (values: SiteUpdateReq) => {
  return await requireAuth<SiteType>(api.patch(`sites`, values))
}

export const updateSiteProperty = async (values) => {
  return await requireAuth<SiteType>(api.post(`sites/property`, values))
}
